<template>
  <div class="input-txt-group">
    <v-text-field
      :type="type"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :name="name"
      v-model="model"
    >
    </v-text-field>
    <ErrorMessage :name="name" class="error-feedback" />
  </div>
</template>
<style lang="scss">
</style>
<script lang="ts" setup>
import { toRef } from "vue";
import { useField, Field, ErrorMessage } from "vee-validate";

const props = defineProps(['placeholder', 'type' ,'readonly', 'disabled', 'modelValue', 'name' ]);
const model = defineModel()
const { value, handleBlur, errors } = useField(toRef(props, "name"), undefined,{ syncVModel: true });
</script>
